import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print } from 'utils';
import { TABS, Tabs, MONEY_TABS } from './physical';
import { MoneyService } from 'services';
import { Table, Pagination, Input, Tooltip, Modal } from 'components';
import { DownloadIcon, CleanIcon, ViewIcon, CloseIcon } from 'assets/icons';
import moment from 'moment';
import ModalView from './modal-view';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: ''
}

class MoneyLiquidity extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Fecha de Registro',
			'Nombre',
			'Correo',
			'Total ($)',
			'Acciones'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Liquidez',
				onBack: null
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await MoneyService.admin.liquidity.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.data?.rows || [],
			last_page: res.data?.count || 1
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	download = async () => {
		const res: any = await MoneyService.admin.liquidity.download({
			...this.state.form,
		});
	    Print(Constants.BASE_STORAGE + res.url);
	}

	view = (e: any, item: any) => {
		e.preventDefault();
		this.props.history.push({
			pathname: `/admin/money/cliente/${ item.id }`,
			state: {
				client: {
					name: item.name,
					lastname: item.lastname,
					email: item.email
				}
			}
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		});
	}

	render() {
		const { visible } = this.state;

		return (
			<div id="admin-money-liquidity">
				<Tabs active={ TABS.LIQUIDITY } />

				<Modal
		          className="modal-view-money"
		          visible={ visible }
		          title="Ver"
		          onClose={ () => this.onClose() }
		        >
		          <ModalView
		          	tab={ MONEY_TABS.LIQUIDITY }
		          	user={ this.state.item }
		          	onClose={ () => this.onClose() }
		          />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="col-md-11 row">
								<div className="col-md-4">
									<Input
										value={ this.state.form.search }
										name="search"
										placeholder="Buscar"
										label="Buscar por nombre o correo"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
							</div>
							<div className="col-md-1">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
				</div>

				<Table title="Liquidez" data={ this.state.data.length } header={ this.state.header } rightAlign={[4]} titleRight={
					<>
						{
							this.state.data.length > 0 && (
								<button className="container-add-table" onClick={ () => this.download() }>
									<img src={ DownloadIcon } />
									<p>Descargar Excel</p>
								</button>
							)
						}
					</>
				}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ moment(i?.created_at).format('YYYY-MM-DD') }</td>
								<td>{ i.name + ' ' + i.lastname }</td>
								<td>{ i.email }</td>
								<td>{ Globals.formatMiles(i?.total_money) }</td>
								<td className="text-right">
									<Tooltip title="Ver">
										<a className="link-icon" href="#" onClick={ (e: any) => this.view(e,i) }>
											<img src={ ViewIcon } />
										</a>
									</Tooltip>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(MoneyLiquidity);